import { validates } from '../utils/ValidateFormObject'

const fluxograma = {
  tipo: {
    required: true
  },
  titulo: {
    required: true
  },
  url: {
    required: true
  },
  autores: {
    required: true
  },
  especialidades: {
    required: true
  },
  pesoDA: {
    required: true
  },
  idioma: {
    required: true
  },
  palavrasChave: {
    required: true
  },
  codigo: {
    required: true,
    func: validates.codigo,
    errorMessage: 'Este código deve seguir o padrão 0000000000000_S00C000X000X.'
  },
  codigoProtheus: {
    required: true,
    func: validates.isbn,
    errorMessage: 'Este campo deve conter um número de ISBN válido.'
  },
  codigoCapitulo: {
    required: true,
    func: validates.codigoCapitulo,
    errorMessage: 'Este código deve seguir o padrão 0000000000000_S00C000.'
  },
  codigoArtigo: {
    required: true,
    func: validates.codigoArtigo,
    errorMessage: 'Este código deve seguir o padrão 0000000000000_S00C000.'
  },
  codigoDeT: {
    required: true,
    func: validates.codigoDeT,
    errorMessage: 'Este código deve seguir o padrão 0000000000000_S00C000.'
  },
  descricao: {
    required: true
  },
  tituloLivro: {
    required: true
  },
  autoresLivro: {
    required: true
  },
  autoresArtigo: {
    required: true
  },
  autoresDeT: {
    required: true
  },
  editoresDeT: {
    required: false
  },
  editoresArtigo: {
    required: false
  },
  isbn: {
    required: true,
    func: validates.isbn,
    errorMessage: 'Este campo deve conter um número de ISBN válido.'
  },
  copyrightLivro: {
    required: true,
    func: validates.copyright,
    errorMessage: 'Este campo deve conter 4 dígitos numéricos.'
  },
  edicaoLivro: {
    required: true
  },
  especialidadesLivro: {
    required: true
  },
  tituloSecao: {
    required: false
  },
  autoresSecao: {
    required: false
  },
  textoSecao: {
    required: false
  },
  tipoOrigem: {
    required: false
  },
  tituloCapitulo: {
    required: true
  },
  tituloArtigo: {
    required: true
  },
  tituloDeT: {
    required: true
  },
  origemId: {
    required: false
  },
  livroReferencia: {
    required: false
  },
  dataAtualizacao: {
    required: true,
    func: validates.date,
    errorMessage: 'Este campo deve conter uma data válida.'
  },
  anoPublicacaoArtigo: {
    required: true,
    func: validates.copyright,
    errorMessage: 'Este campo deve conter 4 dígitos numéricos.'
  },
  anoPublicacaoDeT: {
    required: true,
    func: validates.copyright,
    errorMessage: 'Este campo deve conter 4 dígitos numéricos.'
  },
  minutosLeitura: {
    required: true
  }
}
export default fluxograma



// WEBPACK FOOTER //
// ./src/contentSchema/fluxograma.js